// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iy","advertCardHeader__actions":"c-a_iz","advertCardHeader__bottomLabel":"c-a_iA"};